import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="global-footer"
      className="relative overflow-hidden border-t border-[#27272A] bg-[#070707] px-6 pt-24 pb-12 md:px-12"
    >
      <div className="mx-auto max-w-[1600px]">
        <div className="grid grid-cols-1 gap-16 md:grid-cols-12">
          <div className="md:col-span-7">
            <p className="font-mono-accent text-xs uppercase tracking-[0.2em] text-[#E83D16]">
              [ Let&apos;s build the next media brand ]
            </p>
            <Link
              to="/contact"
              data-testid="footer-contact-cta"
              className="group mt-6 inline-flex items-center gap-4"
            >
              <h2 className="font-display text-4xl leading-none tracking-tight text-[#F5F5F0] transition-colors duration-300 group-hover:text-[#E83D16] sm:text-6xl md:text-7xl">
                Get in touch
              </h2>
              <ArrowUpRight
                className="mt-2 text-[#F5F5F0] transition-transform duration-300 group-hover:translate-x-2 group-hover:-translate-y-1 group-hover:text-[#E83D16]"
                size={44}
              />
            </Link>
          </div>

          <div className="md:col-span-3 md:col-start-9">
            <p className="font-mono-accent text-xs uppercase tracking-[0.2em] text-[#A1A1AA]">
              Navigate
            </p>
            <ul className="mt-6 space-y-3">
              {[
                { label: "Home", to: "/" },
                { label: "Portfolio", to: "/portfolio" },
                { label: "Contact", to: "/contact" },
              ].map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    data-testid={`footer-link-${l.label.toLowerCase()}`}
                    className="link-sweep font-body text-base text-[#F5F5F0] hover:text-[#E83D16]"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
            <p className="mt-8 font-mono-accent text-xs uppercase tracking-[0.2em] text-[#A1A1AA]">
              Contact
            </p>
            <a
              href="mailto:hello@fairmountmedia.group"
              data-testid="footer-email"
              className="link-sweep mt-3 inline-block font-body text-base text-[#F5F5F0] hover:text-[#E83D16]"
            >
              hello@fairmountmedia.group
            </a>
          </div>
        </div>

        <motion.div
          initial={{ opacity: 0.2 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1 }}
          className="mt-24 border-t border-[#27272A] pt-8"
        >
          <h3 className="font-display text-[13vw] leading-[0.85] tracking-tighter text-[#F5F5F0]">
            Fairmount
          </h3>
        </motion.div>

        <div className="mt-8 flex flex-col justify-between gap-4 md:flex-row">
          <p className="font-mono-accent text-xs uppercase tracking-[0.2em] text-[#A1A1AA]">
            &copy; {year} Fairmount Media Group. All rights reserved.
          </p>
          <p className="font-mono-accent text-xs uppercase tracking-[0.2em] text-[#A1A1AA]">
            Building audiences at scale.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
